import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { ValidateContractGainers, ValidateContractNumbers, ValidateContractSigner } from "./types";

const VALIDATE_CONTRACT_NUMBERS = ApiRequestAdapter.create("/contract-validations/numbers", HttpMethod.POST);
const VALIDATE_CONTRACT_SIGNER = ApiRequestAdapter.create("/contract-validations/signers", HttpMethod.POST);
const VALIDATE_CONTRACT_GAINERS = ApiRequestAdapter.create("/contract-validations/gainers", HttpMethod.POST);

export const contractValidationsApi = {
  validateContractNumbers: (request: ValidateContractNumbers): AxiosPromise => {
    return apiService.post(VALIDATE_CONTRACT_NUMBERS.url, request);
  },
  validateContractSigner: (request: ValidateContractSigner): AxiosPromise => {
    return apiService.post(VALIDATE_CONTRACT_SIGNER.url, request);
  },
  validateContractGainers: (request: ValidateContractGainers): AxiosPromise => {
    return apiService.post(VALIDATE_CONTRACT_GAINERS.url, request);
  },
};
